module.exports = __webpack_public_path__ + "Wireframes15.png?e642fe8d6d999484b85ab4eb897142b4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes15.png
// module id = 114
// module chunks = 0